import {
  Badge,
  Box,
  Card,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import { InputSearchbox } from "components/Form/InputSearchbox";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { getAllOcrActivities } from "redux/actions";
import styled from "styled-components";
import {
  Pagination,
  PaginationDetail,
  PaginationFilter,
} from "components/Pagination";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import moment from "moment";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

const OcrActivityContent: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const { isLoading } = useSelector((state: any) => state.globalReducer);
  const { ocrActivities } = useSelector(
    (state: any) => state.ocrActivityReducer
  );
  const { currentPage, totalPage, limitPage, lengthPage } = useSelector(
    (state: any) => state.ocrActivityReducer
  );

  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(10);

  const handleSearchChange = (event: any) => {
    setSearchValue(event.target.value);
    dispatch(getAllOcrActivities(1, event.target.value, limitPage) as any);
  };

  const handleClearSearchChange = () => {
    setSearchValue("");
    dispatch(getAllOcrActivities(currentPage, "", limitPage) as any);
  };

  useEffect(() => {
    dispatch(getAllOcrActivities() as any);
  }, [dispatch]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={"column"}
        style={{ gap: 20 }}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            OCR Activity
          </Text>
        </Box>

        <Box
          display={"flex"}
          flexDirection={isMobile ? "column" : "row"}
          justifyContent={"space-between"}
          style={{ gap: isMobile ? 10 : 20 }}
        >
          <InputSearchbox
            autoComplete="off"
            name="search"
            placeholder="Search..."
            size={32}
            onChange={handleSearchChange}
            onClearButton={handleClearSearchChange}
          />
        </Box>
      </HeaderWrapper>

      <Card maxHeight={"100%"} overflow={"auto"} elevation={2}>
        <Table>
          <TableHead
            position={"sticky"}
            top={0}
            backgroundColor={theme.colors.grey02}
          >
            <TableHeadRow>
              <TableHeadCell>User</TableHeadCell>
              <TableHeadCell>Ticket Name</TableHeadCell>
              <TableHeadCell>Ticket Number</TableHeadCell>
              <TableHeadCell>Ticket Date</TableHeadCell>
              <TableHeadCell>Ticket Time</TableHeadCell>
              <TableHeadCell>Amount</TableHeadCell>
              <TableHeadCell>Date/Time</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={9} />
            ) : !ocrActivities.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={9} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              ocrActivities.map((ocr: any) => {
                return (
                  <TableBodyRow key={ocr.id}>
                    <TableBodyCell>
                      {ocr.user ? ocr.user.name : "-"}
                    </TableBodyCell>
                    <TableBodyCell>{ocr.ticket_name}</TableBodyCell>
                    <TableBodyCell>{ocr.ticket_number}</TableBodyCell>
                    <TableBodyCell>{ocr.ticket_date}</TableBodyCell>
                    <TableBodyCell>{ocr.ticket_time}</TableBodyCell>
                    <TableBodyCell>
                      <Badge
                        size="md"
                        variant="success"
                        style={{
                          paddingLeft: 20,
                          paddingRight: 20,
                        }}
                      >
                        {ocr.ticket_price.toLocaleString()}
                      </Badge>
                    </TableBodyCell>
                    {/* <TableBodyCell>{ocr.store_code}</TableBodyCell> */}
                    <TableBodyCell>
                      {moment(ocr.created_at).format("DD MMMM YYYY, HH:mm:ss")}
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingY={10}
      >
        {!isMobile ? (
          <PaginationDetail
            page={currentPage}
            limit={limitPage}
            length={lengthPage}
          />
        ) : (
          ""
        )}
        <Pagination
          current={currentPage}
          total={totalPage}
          onSelect={(select: any) =>
            dispatch(getAllOcrActivities(select, searchValue, limitPage) as any)
          }
        />
        <PaginationFilter
          selectedItem={limit}
          onChange={(selectedItem) => {
            if (selectedItem) {
              setLimit(selectedItem);
              dispatch(
                getAllOcrActivities(1, searchValue, selectedItem) as any
              );
            }
          }}
          items={[10, 20, 30, 40, 50]}
        />
      </Box>
    </Box>
  );
};

export default OcrActivityContent;
